import type { FaireProductEntity } from "../../entity_types/product";

export const p_854nk72chb: FaireProductEntity = {
  token: "p_854nk72chb",
  type: "product",
  name: "Pumpkin Noir Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl:
    "https://cdn.faire.com/fastly/ad1fe5c77b1dab9d7260f6bcdd72e534fe319deff23fe622e68bda0425e1638c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63151ab8af03f138c00fc4a5224bf51ef63e968166cf56dea95cddc144e68e02.jpeg",
  ],
  priceDollars: 9,
  description:
    'Kitchen Tea Towel\n\nThrow in the (ordinary) towel.\n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\nSKU: TT-MF-pumpkin-noir\nGTIN/UPC: 00840392756648\n\n...\n\n• ♺ Made from post-consumer recycled materials\n• 18" x 30"\n• Single-sided print\n\n...\n\nChore responsibly.\n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours.\n\nImpact your home, not the environment. Discover the Geometry Tea Towel.',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:30.150Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
